






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Tag from "@/components/miscellaneous/Tag.vue";
import moment from "moment";

interface Budget {
    validatedAt: string;
    cancelledAt: string;
    validationDeadline: string;
}

@Component({ components: { Tag } })
export default class Status extends Vue {
    @Prop( { default: null }) public budget!: Budget;

    public dateNow: any = moment().format("YYYY-MM-DD HH:mm:ss");

    public static getNeededFields(): string[] {
        return [
            "budget.validatedAt",
            "budget.cancelledAt",
            "budget.budgetLevers.budget",
        ];
    }
}
